import { PATH } from "routes/paths";

/**
 * 웹퍼널 광고 채널 판정 — 경로 prefix 단일 출처.
 *
 * 같은 퍼널(화면·흐름·Mixpanel promotion 프로젝트 동일)을 광고 채널별로 두 prefix 에서 운영한다.
 * - meta:   /promotion-*, /promotion/oauth/* (레퍼럴 /with/*, /referral* 도 이 퍼널로 합류) — Meta Pixel/CAPI + X Ads
 * - google: /gads-*, /gads/oauth/*                                                           — gtag(Google Ads) 만
 *
 * 채널별 픽셀 게이트는 각 헬퍼 내부(trackCapiStandardEvent, trackXAdsEvent, useGtagConversion)와
 * App.tsx 초기화에서 getAdChannel() 로 처리한다. 호출부는 채널을 신경 쓰지 않는다.
 *
 * pathname 은 호출 시점의 window.location 을 읽는다 — 퍼널 내 이동은 prefix 를 넘나들지 않으므로
 * 하드 로드 시점 판단과 항상 일치하고, 훅이 아니라 App 초기화·axios 인터셉터에서도 쓸 수 있다.
 */
export type AdChannel = "meta" | "google";

export interface FunnelPaths {
  prefix: "promotion" | "gads";
  /** `${onboardingBase}/:type/:id` */
  onboardingBase: string;
  login: string;
  kakaoCallback: string;
  tossSuccess: string;
  tossFail: string;
  completed: string;
  alreadyUsed: string;
}

export const FUNNEL_PATHS: Record<AdChannel, FunnelPaths> = {
  meta: {
    prefix: "promotion",
    onboardingBase: "/promotion-onboarding",
    login: PATH.promotionLogin,
    kakaoCallback: PATH.kakaoLoginRedirectPromotion,
    tossSuccess: PATH.promotionTosspaymentsSuccess,
    tossFail: PATH.promotionTosspaymentsFail,
    completed: PATH.promotionCompleted,
    alreadyUsed: PATH.promotionAlreadyUsed,
  },
  google: {
    prefix: "gads",
    onboardingBase: "/gads-onboarding",
    login: PATH.gadsLogin,
    kakaoCallback: PATH.kakaoLoginRedirectGads,
    tossSuccess: PATH.gadsTosspaymentsSuccess,
    tossFail: PATH.gadsTosspaymentsFail,
    completed: PATH.gadsCompleted,
    alreadyUsed: PATH.gadsAlreadyUsed,
  },
};

export function isGadsPath(pathname: string): boolean {
  return pathname.startsWith("/gads-") || pathname.startsWith("/gads/oauth/");
}

/** 기본값 meta — 메인 앱·레퍼럴 경로도 현재 Meta 픽셀을 초기화하므로 google 이 아닌 곳은 전부 meta 로 본다. */
export function getAdChannel(
  pathname: string = window.location.pathname
): AdChannel {
  return isGadsPath(pathname) ? "google" : "meta";
}

export function getFunnelPaths(
  pathname: string = window.location.pathname
): FunnelPaths {
  return FUNNEL_PATHS[getAdChannel(pathname)];
}
